<template>
    <v-card>
        <v-card-title class="text-h5">{{ athlete.name }}</v-card-title>

        <v-card-text>
            <v-row v-if="error" align="center" class="mx-0 mt-4">
                <v-alert border="left" colored-border type="error" elevation="2">
                    <span v-html="error"></span>
                </v-alert>
            </v-row>

            <v-row align="center" class="mx-0 mb-0 mt-4">
                <v-alert border="left" colored-border type="warning" elevation="2">
                    <span>Please do not provide sensitive or identifying information.</span>
                </v-alert>
            </v-row>

            <v-row align="center" class="mx-0">
                <v-text-field
                    v-model="form.current_residence"
                    label="Current Residence"
                    prepend-icon="mdi-home-account"
                    hint="City or State where you currently reside. DO NOT provide your full address."
                    persistent-hint
                    required
                />
            </v-row>

            <v-row align="center" class="mx-0 mt-4">
                <v-text-field
                    v-model="form.hometown"
                    label="Hometown"
                    prepend-icon="mdi-home"
                    hint="City or State where you're originally from."
                    persistent-hint
                    required
                />
            </v-row>

            <v-row align="center" class="mx-0 mt-4">
                <v-text-field v-model="form.instagram" label="Instagram" prepend-icon="mdi-instagram" required />
            </v-row>

            <v-row align="center" class="mx-0 mt-4">
                <v-text-field v-model="form.facebook" label="Facebook" prepend-icon="mdi-facebook" required />
            </v-row>

            <v-row align="center" class="mx-0 mt-4">
                <v-text-field v-model="form.tiktok" label="TikTok" prepend-icon="mdi-tik-tok" required>
                    <template #prepend>
                        <tik-tok-icon size="1.5x" fill="#fff" />
                    </template>
                </v-text-field>
            </v-row>

            <v-row align="center" class="mx-0 mt-4">
                <v-text-field v-model="form.twitter" label="Twitter" prepend-icon="mdi-twitter" required />
            </v-row>

            <v-row align="center" class="mx-0 mt-4">
                <v-textarea v-model="form.bio" label="Bio" prepend-icon="mdi-pencil" required />
            </v-row>
        </v-card-text>

        <v-card-actions>
            <v-spacer />
            <v-btn @click.prevent="$emit('close')"> Cancel </v-btn>
            <v-btn :loading="submitting" color="primary" @click.prevent="submit"> Update </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import { TikTokIcon } from 'vue-simple-icons';
import Athlete from '@/Models/Athlete.js';

export default {
    name: 'AthleteProfileModal',

    components: { TikTokIcon },

    props: {
        athlete: {
            type: Athlete,
            required: true,
        },
    },

    data() {
        return {
            error: null,
            submitting: false,

            form: {
                current_residence: null,
                hometown: null,
                instagram: null,
                facebook: null,
                tiktok: null,
                bio: null,
            },

            valid: true,
        };
    },

    computed: {},

    created() {
        this.form.current_residence = this.athlete.current_residence;
        this.form.hometown = this.athlete.hometown;
        this.form.instagram = this.athlete.instagram;
        this.form.facebook = this.athlete.facebook;
        this.form.tiktok = this.athlete.tiktok;
        this.form.twitter = this.athlete.twitter;
        this.form.bio = this.athlete.bio;
    },

    methods: {
        async submit() {
            try {
                this.submitting = true;

                await axios.put(`/api/athletes/${this.athlete.id}/profile`, this.form);

                // this.submitting = false;

                window.location.reload();
            } catch (e) {
                if (e.response.status === 422) {
                    this.error = e.response.data.message;
                }

                if (e.response.status === 403) {
                    this.error =
                        'Sorry, it looks like you do not have permission to update this athlete. Please affiliate with the athlete profile first by visiting your <a href="/account">account</a> page.';
                }

                if (e.response.status === 404) {
                    this.error = 'The athlete could not be found.';
                }
            }
        },
    },
};
</script>
